import { LuChevronsRight } from 'react-icons/lu';
import { Link } from 'react-router-dom';
import { BOOKING_HISTORY } from '../../../constants/dashboard';
import { bookHistoryColumns } from '../../../constants/tableColumns';
import DashboardSectionLayout from '../../../layouts/DashboardSectionLayout';
import AcademiaPieChart from '../../CommonComps/Charts/AcademiaPieChart';
import AcademiaDashboardTable from '../../CommonComps/Tables/AcademiaDashboardTable';

const transactionPieData = [
  { name: 'Attended Appointments', value: 10 },
  { name: 'Upcoming Appointments', value: 3 },
];

const BookingHistory = () => {
  // rendering purchase history section component here
  return (
    <section className='grid grid-cols-1 xl:grid-cols-[1fr_60%] 2xl:grid-cols-[1fr_70%] gap-5'>
      <DashboardSectionLayout sectionTitle='Booking Summary'>
        <AcademiaPieChart
          data={transactionPieData}
          totalLabel='Total Bookings'
          total={13}
          colors={[
            '#845adf', // purple
            '#FF8042',
          ]}
        />
      </DashboardSectionLayout>

      <DashboardSectionLayout
        sectionTitle='Booking History'
        additionalClassNames='-order-1 xl:order-1'
      >
        <AcademiaDashboardTable
          data={BOOKING_HISTORY}
          columns={bookHistoryColumns}
        />

        <div className='mt-2 flex items-center justify-end'>
          <Link
            to={'/history/purchase'}
            className='flex items-center justify-center gap-1 text-base-light-blue font-medium hover:opacity-70 active:scale-95 duration-300'
          >
            <span>Show More</span> <LuChevronsRight className='size-6' />
          </Link>
        </div>
      </DashboardSectionLayout>
    </section>
  );
};

export default BookingHistory;
